export const offerStati = [
  {
    key: 'OFFER_CREATED',
    // disabled,
    color: 'var(--color-neutralGrey)',
    borderColor: 'var(--color-neutralGrey)',
    label: 'Opprettet',
  },
  {
    key: 'DRAFT_CREATED',
    // disabled,
    color: 'var(--color-neutralGrey)',
    borderColor: 'var(--color-neutralGrey)',
    label: 'Opprettet',
  },
  {
    key: 'PAUSED',
    // neutral,
    color: 'var(--color-oker20)',
    borderColor: 'var(--color-neutral)',
    label: 'På vent',
  },
  {
    key: 'ORDER_CONFIRM',
    // primary,
    color: 'var(--color-komorebi20)',
    borderColor: 'var(--color-komorebi60)',
    label: 'Sendt',
  },
  {
    key: 'ORDER_SIGNED',
    // positive,
    color: 'var(--color-komorebi20)',
    borderColor: 'var(--color-komorebi60)',
    label: 'Signert',
  },
  {
    key: 'ORDER_FAILURE',
    // negative,
    color: 'var(--color-poppy20)',
    borderColor: 'var(--color-poppy60)',
    label: 'Feilet',
  },
  {
    key: 'OFFER_EXPIRED',
    // negative,
    color: 'var(--color-poppy20)',
    borderColor: 'var(--color-poppy60)',
    label: 'Utløpt',
  },
  {
    key: 'ORDER_COMPLETED',
    // positive,
    color: 'var(--color-komorebi20)',
    borderColor: 'var(--color-komorebi60)',
    label: 'Utlevert',
  },
  {
    key: 'CANCEL_ORDER_SUCCESS',
    // positive,
    color: 'var(--color-komorebi20)',
    borderColor: 'var(--color-komorebi60)',
    label: 'fullført',
  },
  {
    key: 'CANCEL_ORDER_PENDING',
    // negative,
    color: 'var(--color-oker20)',
    borderColor: 'var(--color-oker60)',
    label: 'Pågår',
  },
  {
    key: 'CANCEL_ORDER_FAILED',
    // negative,
    color: 'var(--color-poppy20)',
    borderColor: 'var(--color-poppy60)',
    label: 'Feilet',
  },
];
